module.exports = __webpack_public_path__ + "static/media/om_hairstyle_slickedback_front_vector.7665820a.svg";